import { render } from "./Annexe.vue?vue&type=template&id=2fbc5090"
import script from "./Annexe.vue?vue&type=script&lang=js"
export * from "./Annexe.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__